export default function reverse (arr) {
  const clone = arr.concat()

  return clone.reverse()
}
